import React from 'react';
import PropTypes from 'prop-types';

class InputText extends React.Component {
    componentDidMount() {
        if (this.props.isFocused) {
            this.inputRef.focus();
        }
    }

    render() {
        const rootClass = this.props.bootstrapClass ? `mb-3 ${this.props.bootstrapClass}` : "mb-3";
        const maxLength = this.props.maxLength || 100;

        return (
            <div className={rootClass}>
                <span className={(this.props.label) ? "has-float-label" : ""}>
                    <input
                        className={`form-control${this.props.isValid === false ? " is-invalid" : ""}`}
                        id={this.props.name}
                        name={this.props.name}
                        type={this.props.type}
                        placeholder={this.props.placeholder ?? ""}
                        value={this.props.value}
                        onChange={this.props.onChange}
                        onFocus={this.props.onFocus}
                        onBlur={this.props.onBlur}
                        onKeyUp={this.props.onKeyUp}
                        onKeyDown={this.props.onKeyDown}
                        disabled={this.props.isDisabled}
                        ref={(el) => (this.inputRef = el)}
                        maxLength={maxLength}
                        autoComplete="off"
                        min={this.props.minValue}
                        required={this.props.isRequired}
                        pattern={this.props.pattern}
                    />

                    {this.props.label &&
                        <label htmlFor={this.props.name}>{this.props.label}</label>
                    }

                    {this.props.errorMessage && (
                        <div className="invalid-feedback">{this.props.errorMessage}</div>
                    )}

                    {this.props.hintText && (
                        <div style={{ marginTop: '2px'}}>
                            <small className={`form-text sub-title ${this.props.hintTextWhiteColor ? 'text-light' : 'text-muted'}`}>{this.props.hintText}</small>
                        </div>
                    )}
                </span>
            </div>
        );
    }
}

InputText.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    type: PropTypes.string.isRequired, // e.g., text, email, password
    placeholder: PropTypes.string,
    value: PropTypes.string,
    errorMessage: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyUp: PropTypes.func,
    onKeyDown: PropTypes.func,
    isRequired: PropTypes.bool,
    pattern: PropTypes.string,
    isFocused: PropTypes.bool,
    isValid: PropTypes.bool,
    isDisabled: PropTypes.bool,
    bootstrapClass: PropTypes.string,
    maxLength: PropTypes.number,
    minValue: PropTypes.number,
    hintText: PropTypes.string,
    hintTextWhiteColor: PropTypes.bool,
};

export default InputText;
